import { useState, useEffect } from "react";

const NewsletterPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const hasSubscribedOrClosed = localStorage.getItem("newsletterDismissed");

    if (!hasSubscribedOrClosed) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000); // Adjust delay as needed
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !firstName || !lastName) {
      setMessage("Please fill in all fields.");
      return;
    }

    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch("/api/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, firstName, lastName }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage("Thank you for subscribing! Your free eBook is on its way!");
        localStorage.setItem("newsletterDismissed", "true"); // Mark as subscribed
        setTimeout(() => setIsOpen(false), 2000); // Close after success
      } else {
        setMessage(result.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting subscription:", error);
      setMessage("Server error. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem("newsletterDismissed", "true"); // Mark as closed
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-full max-w-3xl flex rounded-md bg-white shadow-lg">
            {/* Left Section with Image */}
            <div
              className="hidden md:block w-1/2 bg-cover bg-center rounded-l-md"
              style={{
                backgroundImage:
                  "url('https://cdn-icons-png.flaticon.com/512/4627/4627609.png')",
              }}
            ></div>

            {/* Right Section with Content */}
            <div className="relative w-full md:w-1/2 p-6">
              <button
                className="absolute top-2 right-2 rounded-full bg-gray-100 p-2 text-gray-500 hover:bg-gray-200 hover:text-black focus:outline-none"
                onClick={handleClose}
                aria-label="Close"
              >
                &times;
              </button>
              <h2 className="text-2xl font-bold text-gray-900">Get a Free eBook!</h2>
              <p className="mt-2 text-sm text-gray-600">
                Subscribe to our newsletter and receive an exclusive free eBook:{" "}
                <span className="font-semibold">"10 Secrets to PTE Success."</span>
              </p>
              <form className="mt-4" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="w-full rounded border border-gray-300 p-2 text-sm focus:ring focus:ring-blue-200"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="w-full rounded border border-gray-300 p-2 text-sm focus:ring focus:ring-blue-200"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full rounded border border-gray-300 p-2 text-sm focus:ring focus:ring-blue-200"
                  />
                </div>
                <button
                  type="submit"
                  className="mt-4 w-full flex items-center justify-center rounded bg-gray-800 px-4 py-2 text-sm font-bold text-white hover:bg-gray-900 focus:outline-none focus:ring focus:ring-blue-200"
                >
                  {isLoading ? (
                    <svg
                      className="h-5 w-5 animate-spin text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  ) : (
                    "Get Your eBook"
                  )}
                </button>
              </form>
              {message && (
                <p className="mt-2 text-center text-sm text-gray-700">{message}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsletterPopup;
